import { connect } from "react-redux";
import CustomerItems from "../../../presentational/customerItems/CustomerItems";
import {
  getDisplayableItemCount,
  getUserIsAuthenticated,
  getLoadedSavedItems
} from "../../../../state/selectors";

const mapStateToProps = state => ({
  itemCount: getDisplayableItemCount(state),
  isAuthenticated: getUserIsAuthenticated(state),
  loadedSavedItems: getLoadedSavedItems(state)
});

export default connect(mapStateToProps)(CustomerItems);
